import {BaseProvider} from '@exadel/esl/modules/esl-media/core';
import {IframeBasicProvider} from '@exadel/esl/modules/esl-media/providers/iframe-provider';

@BaseProvider.register
export class HttpsMediaProvider extends IframeBasicProvider {
  static override readonly providerName = 'https';
}
